import { CONNECT_STATUSES } from "../../utils/constants";
import { classNames } from "../../utils/formatters";

const statusColors = {
  available: "text-blue-700 bg-blue-100",
  delivered: "text-green-700 bg-green-100",
  cancelled: "text-red-700 bg-red-100",
  in_progress: "text-yellow-800 bg-yellow-100",
};

const statusAnimations = {
  available: "animate-ping",
  delivered: "",
  cancelled: "",
  in_progress: "animate-bounce",
};

export default function ConnectStatusBadge({
  status = CONNECT_STATUSES.available.id,
}: {
  status: string;
}) {
  return (
    <span
      className={classNames(
        "inline-flex items-center gap-x-1.5 rounded-md px-2 py-1 text-xs font-medium",
        statusColors[status]
      )}
    >
      <div
        className={classNames(
          statusColors[status],
          statusAnimations[status],
          "flex-none rounded-full p-1"
        )}
      >
        <div className="h-1.5 w-1.5 rounded-full bg-current" />
      </div>
      {CONNECT_STATUSES[status].label}
    </span>
  );
}
